import React from 'react';
import { FaClipboardCheck, FaUpload, FaFileDownload } from "react-icons/fa";
import styles from "../../../../styles/office/EditModal.module.css";

const ApplicationStatusSection = ({
  language,
  selectedRecord,
  localRecord,
  officerProfile,
  selectedFile,
  handleFieldChange,
  setlocalRecordStatus,
  handleFileChange,
  allHandleDownloadPDF,
  renderReadOnlyField
}) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>
        <FaClipboardCheck className={styles.sectionIcon} />
        {language === 'en' ? 'Application Status' : 'अर्ज स्थिती'}
      </h3>

      {renderReadOnlyField(
        language === 'en' ? 'Current Status' : 'सद्य स्थिती',
        selectedRecord.status ?
          selectedRecord.status.charAt(0).toUpperCase() + selectedRecord.status.slice(1) :
          (language === 'en' ? 'Pending' : 'प्रलंबित')
      )}

      {(selectedRecord.status === 'sendforauthorization' && officerProfile === 'Authorizer') && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Action' : 'कृती'}</label>
          {(officerProfile === "Authorizer") && (
            <select
              value={localRecord.action || ''}
              onChange={(e) => {
                handleFieldChange('action', e.target.value);
                setlocalRecordStatus(e.target.value);
              }}
              className={styles.statusSelect}
            >
              <option value="">{language === 'en' ? 'Select Action' : 'कृती निवडा'}</option>
              <option value="approved">{language === 'en' ? 'Approve Request Manually' : 'मंजूर करा'}</option>
              {/* <option value="approveda">{language === 'en' ? 'Approve Request Automatically' : 'मंजूर करा'}</option> */}
              <option value="rejected">{language === 'en' ? 'Reassign Request' : 'नाकारा'}</option>
              <option value="SendBackforReview">{language === 'en' ? 'Send Back for Review' : 'पुनर्परीक्षणासाठी परत पाठवा'}</option>
            </select>
          )}
        </div>
      )}

      {(selectedRecord.status === 'sendforauthorizationmanully' && officerProfile === 'Authorizer') && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Action' : 'कृती'}</label>
          {(officerProfile === "Authorizer") && (
            <select
              value={localRecord.action || ''}
              onChange={(e) => {
                handleFieldChange('action', e.target.value);
                setlocalRecordStatus(e.target.value);
              }}
              className={styles.statusSelect}
            >
              <option value="">{language === 'en' ? 'Select Action' : 'कृती निवडा'}</option>
              <option value="approvemanully">{language === 'en' ? 'Approve' : 'नाकारा'}</option>
              <option value="sendbackforreview">{language === 'en' ? 'Send Back for Review' : 'पुनर्परीक्षणासाठी परत पाठवा'}</option>
            </select>
          )}
        </div>
      )}

      {(selectedRecord.status === 'sendforauthorizationautomatically' && officerProfile === 'Authorizer') && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Action' : 'कृती'}</label>
          {(officerProfile === "Authorizer") && (
            <select
              value={localRecord.action || ''}
              onChange={(e) => {
                handleFieldChange('action', e.target.value);
                setlocalRecordStatus(e.target.value);
              }}
              className={styles.statusSelect}
            >
              <option value="">{language === 'en' ? 'Select Action' : 'कृती निवडा'}</option>
              <option value="approveautomatically">{language === 'en' ? 'Approve' : 'नाकारा'}</option>
              <option value="sendbackforreview">{language === 'en' ? 'Send Back for Review' : 'पुनर्परीक्षणासाठी परत पाठवा'}</option>
            </select>
          )}
        </div>
      )}

      {(selectedRecord.status === 'pending' || selectedRecord.status === 'Pending' || selectedRecord.status === 'sendbackforreview') && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Action' : 'कृती'}</label>
          {(officerProfile === "Draftman") && (
            <select
              value={localRecord.action || ''}
              onChange={(e) => {
                handleFieldChange('action', e.target.value);
                setlocalRecordStatus(e.target.value);
              }}
              className={styles.statusSelect}
            >
              <option value="">{language === 'en' ? 'Select Action' : 'कृती निवडा'}</option>
              <option value="reassigned">{language === 'en' ? 'Reassign Request' : 'नाकारा'}</option>
               {/* <option value="sendforauthorizationmanully">{language === 'en' ? 'Approve Request Manually' : 'मंजूर करा'}</option>  */}
               <option value="approvemanully">{language === 'en' ? 'Approve Request Manually' : 'मंजूर करा'}</option> 
              
              
              
              {/* <option value="sendforauthorizationautomatically">{language === 'en' ? 'Approve Request Automatically' : 'मंजूर करा'}</option> */}
            </select>
          )}

          {(officerProfile === "Authorizer") && (
            <select
              value={localRecord.action || ''}
              onChange={(e) => {
                handleFieldChange('action', e.target.value);
                setlocalRecordStatus(e.target.value);
              }}
              className={styles.statusSelect}
            >
              <option value="">{language === 'en' ? 'Select Action' : 'कृती निवडा'}</option>
              <option value="SendBackforReview">{language === 'en' ? 'Reassigned' : 'पुनर्परीक्षणासाठी परत पाठवा'}</option>
              <option value="approveda">{language === 'en' ? 'Approve' : 'पुनर्परीक्षणासाठी परत पाठवा'}</option>
            </select>
          )}
        </div>
      )}


    {(localRecord.action === 'approvemanully') && (
        <>
          {localRecord.certificatePath ? (
            renderReadOnlyField(
              language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
              <a
                href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.certificatePath}`}
                download
                className={styles.fileLink}
              >
                <FaFileDownload /> {language === 'en' ? 'Download Certificate' : 'प्रमाणपत्र डाउनलोड करा'}
              </a>
            )
          ) : (
            localRecord.approved_m_or_a === 'automatic' ? (
              renderReadOnlyField(
                language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
                <button
                  type="button"
                  onClick={allHandleDownloadPDF}
                  className={styles.fileLink}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <FaFileDownload /> {language === 'en' ? 'Download Certificate ' : 'प्रमाणपत्र डाउनलोड करा'}
                </button>
              )
            ) : (
              <div className={styles.formGroup}>
                <label>{language === 'en' ? 'Upload Document' : 'दस्तऐवज अपलोड करा'}</label>
                <label className={styles.uploadButton}>
                  <FaUpload /> {language === 'en' ? 'Select File' : 'फाइल निवडा'}
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept="application/pdf"
                  />
                </label>
                {selectedFile && (
                  <div className={styles.fileInfo}>
                    {language === 'en' ? 'Selected file:' : 'निवडलेली फाइल:'} {selectedFile.name}
                  </div>
                )}
              </div>
            )
          )}
        </>
      )}


      {/* {(localRecord.action === 'sendforauthorizationmanully') && (
        <>
          {localRecord.certificatePath ? (
            renderReadOnlyField(
              language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
              <a
                href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.certificatePath}`}
                download
                className={styles.fileLink}
              >
                <FaFileDownload /> {language === 'en' ? 'Download Certificate' : 'प्रमाणपत्र डाउनलोड करा'}
              </a>
            )
          ) : (
            localRecord.approved_m_or_a === 'automatic' ? (
              renderReadOnlyField(
                language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
                <button
                  type="button"
                  onClick={allHandleDownloadPDF}
                  className={styles.fileLink}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <FaFileDownload /> {language === 'en' ? 'Download Certificate ' : 'प्रमाणपत्र डाउनलोड करा'}
                </button>
              )
            ) : (
              <div className={styles.formGroup}>
                <label>{language === 'en' ? 'Upload Document' : 'दस्तऐवज अपलोड करा'}</label>
                <label className={styles.uploadButton}>
                  <FaUpload /> {language === 'en' ? 'Select File' : 'फाइल निवडा'}
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept="application/pdf"
                  />
                </label>
                {selectedFile && (
                  <div className={styles.fileInfo}>
                    {language === 'en' ? 'Selected file:' : 'निवडलेली फाइल:'} {selectedFile.name}
                  </div>
                )}
              </div>
            )
          )}
        </>
      )} */}

      {(localRecord.action === 'approved' ||
        localRecord.status === 'approved' ||
        localRecord.status === 'approvemanully' ||
        localRecord.status === 'approveautomatically' ||
        localRecord.status === 'Approved') && (
          <>
            {localRecord.certificatePath ? (
              renderReadOnlyField(
                language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
                <a
                  href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.certificatePath}`}
                  download
                  className={styles.fileLink}
                >
                  <FaFileDownload /> {language === 'en' ? 'Download Certificate' : 'प्रमाणपत्र डाउनलोड करा'}
                </a>
              )
            ) : (
              (localRecord.approved_m_or_a === 'automatic' || localRecord.approved_m_or_a === 'manualy') ? (
                renderReadOnlyField(
                  language === 'en' ? 'Uploaded Document' : 'अपलोड केलेला दस्तऐवज',
                  <button
                    type="button"
                    onClick={allHandleDownloadPDF}
                    className={styles.fileLink}
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                  >
                    <FaFileDownload /> {language === 'en' ? 'Download Certificate ' : 'प्रमाणपत्र डाउनलोड करा'}
                  </button>
                )
              ) : (
                <div className={styles.formGroup}>
                  <label>{language === 'en' ? 'Upload Document' : 'दस्तऐवज अपलोड करा'}</label>
                  <label className={styles.uploadButton}>
                    <FaUpload /> {language === 'en' ? 'Select File' : 'फाइल निवडा'}
                    <input
                      type="file"
                      onChange={handleFileChange}
                      accept="application/pdf"
                    />
                  </label>
                  {selectedFile && (
                    <div className={styles.fileInfo}>
                      {language === 'en' ? 'Selected file:' : 'निवडलेली फाइल:'} {selectedFile.name}
                    </div>
                  )}
                </div>
              )
            )}
          </>
        )}

        

      {(localRecord.action === 'rejected' ||
        localRecord.status === 'rejected' ||
        localRecord.status === 'sendbackforreview' ||
        localRecord.action === 'sendbackforreview' ||
        localRecord.status === 'Rejected' ||
        localRecord.action === 'reassigned') && (
          <div className={styles.formGroup}>
            <label>{language === 'en' ? 'Remark' : 'शेरा'}</label>
            <input
              type="text"
              value={localRecord.remark || ''}
              onChange={(e) => { handleFieldChange('remark', e.target.value); handleFieldChange('status', "rejected"); }}
              className={styles.editableInput}
              required={localRecord.action === 'rejected' || localRecord.status === 'rejected'}
            />
          </div>
        )}

{console.log("test local record : ")}
{console.log(localRecord)}

      {(localRecord.status === 'approved' || localRecord.status === 'Approved') && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Remark' : 'शेरा'}</label>
          <input
            type="text"
            value={localRecord.remark || ''}
            onChange={(e) => handleFieldChange('remark', e.target.value)}
            className={styles.editableInput}
          />
        </div>
      )}
    </div>
  );
};

export default ApplicationStatusSection;